export default {
      id: "ic_stop_watch-usage",
      viewBox: "0 0 16 16",
      url: "/" + "images/icons.3.109.2.svg#ic_stop_watch-usage",
      toString: function () {
        return this.url;
      }
    }